/* eslint-disable ember/no-computed-properties-in-native-classes */
import EmberObject, { computed } from '@ember/object';

import FrequencyRange from '../process-data/frequency';
import AdiMath from '../utils/math';

export default class BaseOptimization extends EmberObject {
  stopbandFrequency;

  @computed('stopbandFrequency') get opAmpRequirementSpecValues() {
    var stopbandFrequency = this.stopbandFrequency;
    var result = this.getOpAmpRequirementSpecValues(stopbandFrequency);
    return result;
  }

  processR3R4Value(stageFp, rMin, rMax) {
    var F_MAX = 10000000;
    var rFreq = Math.sqrt(F_MAX / stageFp) * rMin;
    var result = Math.min(rFreq, rMax);

    return result;
  }

  adjustOpAmpRequirementSpecs(specs, stopbandFrequency) {
    /*If getting to top end of tool, allow more leeway*/
    if (stopbandFrequency > 1e6 && stopbandFrequency < 10e6) {
      specs.fMultiplier = specs.fMultiplier / 1.5;
      specs.allowedError = specs.allowedError * 1.5;
      specs.rOutFreqMultiplier = specs.rOutFreqMultiplier / 2;
    }
    if (stopbandFrequency >= 10e6) {
      specs.fMultiplier = specs.fMultiplier / 5;
      specs.allowedError = specs.allowedError * 2; //Be careful making this higher than 2. If allowedError * this number >= 1, then low pass first order chokes.
      specs.rOutFreqMultiplier = specs.rOutFreqMultiplier / 10;
    }

    return specs;
  }

  computeOptimizationFrequencyArray(filterFrequencyRange) {
    const NUM_FREQ_POINTS = 50;
    const stopFrequency = filterFrequencyRange.stopFrequency;
    const startFrequency = filterFrequencyRange.startFrequency;
    const pointsPerDecade = NUM_FREQ_POINTS / AdiMath.logBaseTen(stopFrequency / startFrequency);

    var newFrequencyArrayObject = FrequencyRange.create({
      startFrequency: startFrequency,
      stopFrequency: stopFrequency,
      pointsPerDecade: pointsPerDecade,
    });
    var result = newFrequencyArrayObject.narrowFrequencyArray;
    return result;
  }

  optimizeStageOrder(stages) {
    return stages;
  }
}
